<template>
  <div
    class="steps steps1 steps--1 lp-section width-expand padding-2xl-vertical l:padding-max-vertical"
    :class="`bg-${backgroundColor}`"
    :id="`Steps1-${pageUid}`">
    <div class="container margin-auto-inline">
      <div class="title-block flex flex-center width-expand">
        <h2
          class="text-3xl l:text-max text-center line-height-090"
          :class="`c-${titleColor}`">
          <span class="" style="line-height: 0.7" v-html="nl2Br(title)"></span>
        </h2>
      </div>

      <div class="flex-column l:flex-row flex-center gap-2xl">
        <div class="step" v-for="step in steps">
          <div class="step-title relative">
            <h3
              :class="`c-${itemTitleColor}`"
              class="bold text-2xl margin-m-bottom step-title-text margin-remove relative">
              {{ step.title }}
            </h3>
          </div>

          <div class="step-content" :class="`c-${itemTextColor}`">
            <p class="text-l">
              {{ step.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      steps: [
        {
          title: "",
          content: "",
        },
      ],
      backgroundColor: "",
      titleColor: "",
      itemTitleColor: "",
      textColor: "",
      stepNumberBackgroundColor: "",
      stepNumberTextColor: "",
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {
    counterBgColorProperty() {
      return `var(--c-${this.stepNumberBackgroundColor})`;
    },
    counterTextColorProperty() {
      return `var(--c-${this.stepNumberTextColor})`;
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.steps1 {
  counter-reset: stepCounter;

  .title-block {
    margin-bottom: calc(var(--margin-max) * 0.7);
    font-weight: 600;

    @media (max-width: 1024px) {
      margin-bottom: calc(var(--margin-max) * 0.6);
    }
  }

  .step {
    padding-inline-start: 90px;
    max-width: 800px;
    width: 360px;
    @media (max-width: 1024px) {
      padding-inline-start: 70px;
      width: auto;
    }

    .step-title-text {
      &::before {
        /* Increment the counter */
        counter-increment: stepCounter;
        /* Display the counter */
        content: counter(stepCounter);
        position: absolute;
        font-size: 50px;
        font-weight: 300;
        width: 70px;
        height: 70px;
        top: 50%;
        transform: translateY(-50%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        background: v-bind(counterBgColorProperty);
        color: v-bind(counterTextColorProperty);
        inset-inline-start: -90px;

        @media (max-width: 1024px) {
          width: 50px;
          height: 50px;
          font-size: 40px;
          inset-inline-start: -70px;
        }
      }
    }
  }
}
</style>
